var ajaxIsLoading = false;
clearCart();
function addToCartApi(quantity, id) {
  return $.ajax({ 
    type: 'POST', 
    url: '/cart/add.js', 
    dataType: 'json',
    data: { 
      quantity: quantity, 
      id: id 
    }
  });
}

function changeQuantityApi(quantity, id) {
  return $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: { 
      quantity: quantity, 
      id: id
    }
  });
}

function getCartApi() {
  return $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json'
  });
}

function clearCart() {
  return $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    dataType: 'json'
  });
}